import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-292e6a62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-with-icon" }
const _hoisted_2 = { class: "field-with-icon" }
const _hoisted_3 = { class: "field-with-icon" }
const _hoisted_4 = { class: "field-with-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_caixa = _resolveComponent("selecionar-caixa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { titulo: "CAIXA EM OPERAÇÃO" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: 24,
                xl: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Caixa",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_icone, {
                          class: "ss-icone",
                          nome: "mod-7"
                        }),
                        _createVNode(_component_selecionar_caixa, {
                          class: "ellipsis",
                          empresas: [_ctx.props.empresa],
                          codigoSelecionado: _ctx.props.abertura.codigoCaixa,
                          disabled: ""
                        }, null, 8, ["empresas", "codigoSelecionado"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                xl: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Data Abertura",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_icone, {
                          class: "ss-icone",
                          nome: "calendario-preenchido"
                        }),
                        _createVNode(_component_selecionar_data, {
                          class: "ellipsis",
                          horaMinutoSegundo: true,
                          dataSelecionada: _ctx.props.abertura.dataAbertura,
                          disabled: ""
                        }, null, 8, ["dataSelecionada"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                xl: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Responsável",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_icone, {
                          class: "ss-icone",
                          nome: "usuario-preenchido"
                        }),
                        _createVNode(_component_selecionar_usuario, {
                          class: "ellipsis",
                          empresas: [_ctx.props.empresa],
                          codigoSelecionado: _ctx.props.abertura.codigoResponsavel,
                          disabled: ""
                        }, null, 8, ["empresas", "codigoSelecionado"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: 24,
                xl: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Operador",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_icone, {
                          class: "ss-icone",
                          nome: "usuario-preenchido"
                        }),
                        _createVNode(_component_selecionar_usuario, {
                          class: "ellipsis",
                          empresas: [_ctx.props.empresa],
                          codigoSelecionado: _ctx.props.abertura.codigoOperador,
                          disabled: ""
                        }, null, 8, ["empresas", "codigoSelecionado"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}